webpackJsonp([1],{

/***/ 16:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return commas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return percent; });
/* unused harmony export clone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

var Big = __webpack_require__(188);
var commas = function commas(number) {
  var dp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  return new Big(number).round(dp).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
var percent = function percent(number) {
  var dp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var multiply = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return new Big(number).times(multiply || 1).round(dp).toString() + '%';
};
var clone = function clone(obj) {
  if (obj === null || (typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj)) !== 'object' || 'isActiveClone' in obj) {
    return obj;
  }
  if (obj instanceof Date) {
    var temp = new obj.constructor();
  } else {
    temp = obj.constructor();
  }

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      obj['isActiveClone'] = null;
      temp[key] = clone(obj[key]);
      delete obj['isActiveClone'];
    }
  }

  return temp;
};

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(276)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(171),
  /* template */
  __webpack_require__(298),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 168:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return returnSpecialStacked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return makeSpecialStacked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return makeBlockChart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return returnRoadChartData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return makeRoadChart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return makeStacked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return makeChart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return makeLine; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_chart_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_utils_js__ = __webpack_require__(16);




var globalOptions = {
  deferred: {
    enabled: true
  },
  maintainAspectRatio: true,
  responsive: false,

  title: {
    display: true
  },
  tooltips: {
    display: true,
    displayColors: false,
    callbacks: {
      title: function title() {
        return '';
      }
    }
  },
  animation: {
    onComplete: function onComplete() {}
  },
  legend: {
    display: false,
    position: 'right'
  },
  legendCallback: function legendCallback(chart) {
    var legend = '<ul class="legend-ul">';
    for (var i = 0; i < chart.data.datasets.length; i++) {
      var data = chart.data.datasets[i];
      var color = chart.config.options.legend.labels.fontColor;
      legend += '<li style="color:' + color + '">';

      legend += '<div class="legend-click" style="background-color:' + data.backgroundColor + '">';
      legend += '</div>';

      legend += chart.data.datasets[i].label;

      legend += '</li>';
    }
    legend += '</ul>';
    return legend;
  },
  defaultFontFamily: 'Helvetica',
  yAxes: {
    display: true
  },
  xAxes: {
    display: true
  }
};
__WEBPACK_IMPORTED_MODULE_1_chart_js___default.a.defaults.global = MergeRecursive(__WEBPACK_IMPORTED_MODULE_1_chart_js___default.a.defaults.global, globalOptions);
var charts = function charts(city) {
  return {
    'urban_extent_composition_stacked_bar': {
      labels: [city.City.t1.substr(0, 4), city.City.t2.substr(0, 4), city.City.t3.substr(0, 4)],
      datasets: [{
        backgroundColor: 'rgba(52,22,186,1)',
        borderWidth: 0,
        label: ['Urban Built Up'],
        data: [city.DataSet.urban_extent_composition_urban_t1, city.DataSet.urban_extent_composition_urban_t2, city.DataSet.urban_extent_composition_urban_t3]
      }, {
        backgroundColor: 'rgba(194,121,159,1)',
        borderWidth: 0,
        label: ['Suburban Built Up'],
        data: [city.DataSet.urban_extent_composition_suburban_t1, city.DataSet.urban_extent_composition_suburban_t2, city.DataSet.urban_extent_composition_suburban_t3]
      }, {
        backgroundColor: 'rgba(0,0,0,1)',
        borderWidth: 0,
        label: ['Rural Built Up'],
        data: [city.DataSet.urban_extent_composition_rural_t1, city.DataSet.urban_extent_composition_rural_t2, city.DataSet.urban_extent_composition_rural_t3]
      }, {
        backgroundColor: 'rgba(247,245,80,1)',
        borderWidth: 0,
        label: ['Urbanized Open Space'],
        data: [city.DataSet.urban_extent_composition_open_t1, city.DataSet.urban_extent_composition_open_t2, city.DataSet.urban_extent_composition_open_t3]
      }]
    },
    'roads_width_stacked_bar': {
      labels: [city.City.t1.substr(0, 4) + '-' + city.City.t2.substr(0, 4), city.City.t2.substr(0, 4) + '-' + city.City.t3.substr(0, 4)],
      datasets: [{
        backgroundColor: '#889A9A',
        borderWidth: 0,
        label: '<4m',
        data: [city.DataSet.roads_width_under_4m_pre_1990 * 100, city.DataSet.roads_width_under_4m_1990_2015 * 100]
      }, {
        backgroundColor: '#93AFA9',
        borderWidth: 0,
        label: '4-8m',
        data: [city.DataSet.roads_width_4_8m_pre_1990 * 100, city.DataSet.roads_width_4_8m_1990_2015 * 100]
      }, {
        backgroundColor: '#9FC3B5',
        borderWidth: 0,
        label: '8-12m',
        data: [city.DataSet.roads_width_8_12m_pre_1990 * 100, city.DataSet.roads_width_8_12m_1990_2015 * 100]
      }, {
        backgroundColor: '#AED7C0',
        borderWidth: 0,
        label: '12-16m',
        data: [city.DataSet.roads_width_12_16m_pre_1990 * 100, city.DataSet.roads_width_12_16m_1990_2015 * 100]
      }, {
        backgroundColor: '#BFECCA',
        borderWidth: 0,
        label: '>16m',
        data: [city.DataSet.roads_width_over_16m_pre_1990 * 100, city.DataSet.roads_width_over_16m_1990_2015 * 100]
      }]
    },
    'arterial_roads': {
      labels: ['City', 'Region', 'World'],
      datasets: [{
        label: 'Wide',
        suffix: '_wide_',
        backgroundColor: '#F1E0DE',
        borderWidth: 0
      }, {
        label: 'Narrow',
        suffix: '_narrow_',
        backgroundColor: '#E1C6C4',
        borderWidth: 0
      }, {
        label: 'All',
        suffix: '_all_',
        backgroundColor: '#CEADA9',
        borderWidth: 0
      }]
    },
    'blocks_and_plots_composition_special_stacked': {
      labels: ['City', 'Region', 'World'],
      datasets: [{
        suffix: '_atomistic_',
        bgColor: 'rgba(202,145,121,1)',
        label: 'Atomistic Settlements'
      }, {
        suffix: '_informal_',
        bgColor: 'rgba(197,97,77,1)',
        label: 'Informal Subdivisions'
      }, {
        suffix: '_formal_',
        bgColor: 'rgba(164,53,43,1)',
        label: 'Formal Subdivisions'
      }, {
        suffix: '_housing_',
        bgColor: 'rgba(126,8,18,1)',
        label: 'Housing Projects'
      }]
    }
  };
};

var returnSpecialStacked = function returnSpecialStacked(prefix, city) {
  var laterYear = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var field = prefix.replace('_special_stacked', '');

  var data1990 = {
    labels: charts(city)[prefix].labels,
    datasets: []
  };
  var data2015 = {
    labels: charts(city)[prefix].labels,
    datasets: []
  };

  charts(city)[prefix].datasets.forEach(function (dataset) {
    var data = {
      backgroundColor: dataset.bgColor,
      borderWidth: 0,
      label: dataset.label,
      data: [city.DataSet[field + dataset.suffix + 'pre_1990'], city.Region.DataSet[field + dataset.suffix + 'pre_1990'], city.World.DataSet[field + dataset.suffix + 'pre_1990']]
    };
    data1990.datasets.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)));
    data.data = [city.DataSet[field + dataset.suffix + '1990_2015'], city.Region.DataSet[field + dataset.suffix + '1990_2015'], city.World.DataSet[field + dataset.suffix + '1990_2015']];
    data2015.datasets.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)));
  });
  return laterYear ? data2015 : data1990;
};

var makeSpecialStacked = function makeSpecialStacked(prefix, city) {
  var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var laterYear = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  var ctx = document.getElementById(prefix);

  return new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(ctx, {
    type: 'horizontalBar',
    data: returnSpecialStacked(prefix, city, laterYear),
    options: {
      legend: {
        labels: {
          fontColor: '#4A4A4A',
          boxWidth: 10
        }
      },
      tooltips: {
        callbacks: {
          title: function title() {
            return false;
          },
          label: function label(tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label;
            var amount = tooltipItem.xLabel;

            return percentageTooltip(amount, label);
          }
        }
      },
      title: {
        text: title
      },
      scales: {
        yAxes: stackedYAxes(prefix),
        xAxes: stackedXAxes(prefix)
      }
    }
  });
};

var makeBlockChart = function makeBlockChart(prefix, city) {
  var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var unit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var multiply = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  var ctx = document.getElementById(prefix);
  var field = prefix.replace('_bar', '');

  var data = {
    labels: ['Informal', 'Formal'],
    datasets: [{
      label: city.City.t1.substr(0, 4) + '-' + city.City.t2.substr(0, 4),
      backgroundColor: 'rgba(229,223,227,1.0)',
      borderWidth: 0,
      data: [city.DataSet[field + '_informal_plot_pre_1990'], city.Region.DataSet[field + '_formal_plot_pre_1990']]
    }, {
      label: city.City.t2.substr(0, 4) + '-' + city.City.t3.substr(0, 4),
      backgroundColor: 'rgba(176,171,174,1.0)',
      borderWidth: 0,
      data: [city.DataSet[field + '_informal_plot_1990_2015'], city.Region.DataSet[field + '_formal_plot_1990_2015']]
    }]
  };
  var yAxes = [{
    ticks: {
      beginAtZero: true,
      callback: function callback(value, index, values) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_utils_js__["a" /* commas */])(value);
      }
    }
  }];
  var xAxes = [{
    ticks: {
      beginAtZero: true
    },
    gridLines: {
      display: false
    }
  }];
  return new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(ctx, {
    type: 'bar',
    data: data,
    options: {
      legend: {
        labels: {
          fontColor: '#929292',
          boxWidth: 10
        }
      },
      tooltips: {
        callbacks: {
          label: function label(tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label;

            return bigTooltip(tooltipItem.yLabel, label, unit);
          }
        }
      },
      title: {
        text: title
      },
      scales: {
        yAxes: yAxes,
        xAxes: xAxes
      }
    }
  });
};

var returnRoadChartData = function returnRoadChartData(prefix, city) {
  var laterYear = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var field = prefix.replace('_bar', '');
  var data1990 = {
    labels: charts(city).arterial_roads.labels,
    datasets: []
  };
  var data2015 = {
    labels: charts(city).arterial_roads.labels,
    datasets: []
  };

  charts(city).arterial_roads.datasets.forEach(function (dataset) {
    var data = {
      backgroundColor: dataset.backgroundColor,
      borderWidth: 0,
      label: dataset.label,
      data: [city.DataSet[field + dataset.suffix + 'pre_1990'], city.Region.DataSet[field + dataset.suffix + 'pre_1990'], city.World.DataSet[field + dataset.suffix + 'pre_1990']]
    };
    data1990.datasets.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)));

    data.data = [city.DataSet[field + dataset.suffix + '1990_2015'], city.Region.DataSet[field + dataset.suffix + '1990_2015'], city.World.DataSet[field + dataset.suffix + '1990_2015']];
    data2015.datasets.push(JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)));
  });
  return laterYear ? data2015 : data1990;
};

var makeRoadChart = function makeRoadChart(prefix, city) {
  var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var unit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var multiply = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var laterYear = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;

  var ctx = document.getElementById(prefix);

  return new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(ctx, {
    type: 'horizontalBar',
    data: returnRoadChartData(prefix, city, laterYear),
    options: {
      legend: {
        labels: {
          fontColor: '#929292',
          boxWidth: 10
        }
      },
      gridLines: {
        display: false
      },
      tooltips: {
        callbacks: {
          title: function title() {
            return false;
          },
          label: function label(tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label;
            var number = tooltipItem.xLabel;
            if (unit === '%') {
              return percentageTooltip(number, label, multiply);
            } else {
              return bigTooltip(number, label, unit);
            }
          }
        }
      },
      title: {
        text: title
      },
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          },
          gridLines: {
            display: false
          }
        }],
        xAxes: [{
          ticks: {
            beginAtZero: true,

            callback: function callback(value, index, values) {
              if (multiply) {
                value *= multiply;
              }
              value = Math.floor(value * 100) / 100;
              if (unit && (unit === '%' || unit === 'm')) {
                value += unit;
              }
              return value;
            }
          }
        }]
      }
    }
  });
};

var makeStacked = function makeStacked(prefix, city, title) {
  var unit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var multiply = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var vert = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  var ctx = document.getElementById(prefix);


  var data = charts(city)[prefix];
  return new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(ctx, {
    type: vert ? 'bar' : 'horizontalBar',
    data: data,
    options: {
      legend: {
        labels: {
          fontColor: '#4A4A4A',
          boxWidth: 10
        }
      },
      tooltips: {
        callbacks: {
          title: function title() {
            return false;
          },
          label: function label(tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label;
            var number = vert ? tooltipItem.yLabel : tooltipItem.xLabel;
            return percentageTooltip(number, label, multiply);
          }
        }
      },
      title: {
        text: title
      },
      scales: {
        yAxes: vert ? stackedXAxes(prefix, multiply) : stackedYAxes(prefix),
        xAxes: vert ? stackedYAxes(prefix) : stackedXAxes(prefix, multiply)
      }
    }
  });
};

var makeChart = function makeChart(prefix, city, title) {
  var unit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var multiply = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var side = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  var ctx = document.getElementById(prefix);
  var field = prefix.replace('_bar', '');
  var suffix1 = side ? '_pre_1990' : '_t1_t2';
  var suffix2 = side ? '_1990_2015' : '_t2_t3';
  var data = {
    labels: [city.City.name, city.Region.name, 'World'],
    datasets: [{
      label: side ? city.City.t1.substr(0, 4) + '-' + city.City.t2.substr(0, 4) : city.City.t1.substr(0, 4) + '-' + city.City.t2.substr(0, 4),
      backgroundColor: '#FE8B73',
      borderWidth: 0,
      data: [city.DataSet[field + suffix1], city.Region.DataSet[field + suffix1], city.World.DataSet[field + suffix1]]
    }, {
      label: side ? city.City.t2.substr(0, 4) + '-' + city.City.t3.substr(0, 4) : city.City.t2.substr(0, 4) + '-' + city.City.t3.substr(0, 4),
      backgroundColor: '#A2A09D',
      borderWidth: 0,
      data: [city.DataSet[field + suffix2], city.Region.DataSet[field + suffix2], city.World.DataSet[field + suffix2]]
    }]
  };

  var yAxes = [{
    ticks: {
      beginAtZero: true,
      callback: function callback(value, index, values) {
        if (side) {
          if (multiply) {
            value *= multiply;
          }
          value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_utils_js__["a" /* commas */])(value);

          if (unit === '%' || unit === 'm') {
            value += unit;
          }
          return value;
        } else {
          value = Math.floor(value * 100) / 100;

          return value + '%';
        }
      }
    }
  }];
  var xAxes = [{
    ticks: {
      beginAtZero: true,
      callback: function callback(value, index, values) {
        return fold(value, 15, true);
      }
    },
    gridLines: {
      display: false
    }
  }];
  return new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(ctx, {
    type: side ? 'horizontalBar' : 'bar',
    data: data,
    options: {
      legend: {
        labels: {
          fontColor: '#929292',
          boxWidth: 10
        }
      },
      gridLines: {
        display: false
      },
      tooltips: {
        callbacks: {
          title: function title() {
            return false;
          },
          label: function label(tooltipItem, data) {
            var label = data.datasets[tooltipItem.datasetIndex].label;
            if (side) {
              var number = tooltipItem.xLabel;
              if (unit === '%') {
                return percentageTooltip(number, label, multiply);
              }
              return bigTooltip(number, label, unit);
            } else {
              var _number = tooltipItem.yLabel;
              return percentageTooltip(_number, label, multiply);
            }
          }
        }
      },
      title: {
        text: title
      },
      scales: {
        yAxes: side ? xAxes : yAxes,
        xAxes: side ? yAxes : xAxes
      }
    }
  });
};

var makeLine = function makeLine(prefix, city, title) {
  var unit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

  var ctx = document.getElementById(prefix);
  var field = prefix.replace('_line', '');
  var data = {
    labels: [city.City.t1, city.City.t2, city.City.t3],
    datasets: [{
      pointRadius: 5,
      borderJoinStyle: 'miter',
      lineTension: 0,
      borderWidth: 1,
      borderColor: '#7b7b7b',
      pointBorderColor: '#7b7b7b',
      pointBorderWidth: 1,
      fill: false,
      label: title,
      data: [city.DataSet[field + '_t1'], city.DataSet[field + '_t2'], city.DataSet[field + '_t3']]
    }]
  };
  var max = Math.max.apply(Math, data.datasets[0].data);
  var min = Math.min.apply(Math, data.datasets[0].data.filter(Boolean));
  var log = Math.floor(Math.log(max) / Math.log(10));
  log = Math.pow(10, log);
  var yMax = Math.ceil((max + min) / log) * log;

  return new __WEBPACK_IMPORTED_MODULE_1_chart_js___default.a(ctx, {
    type: 'line',
    data: data,
    options: {
      maintainAspectRatio: true,
      tooltips: {
        callbacks: {
          label: function label(tooltipItem, data) {
            var label = tooltipItem.xLabel.substr(0, 4);
            var number = tooltipItem.yLabel;
            var tool = bigTooltip(number, label, unit);
            return tool;
          }
        }
      },
      title: {
        text: title
      },
      legend: {
        display: false
      },
      scales: {
        yAxes: [{
          ticks: {
            min: 0,
            max: yMax,
            callback: function callback(value, index, values) {
              return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_utils_js__["a" /* commas */])(value);
            }
          }
        }],
        xAxes: [{
          type: 'time',
          time: {
            displayFormats: {
              quarter: 'MMM YYYY'
            },
            min: new Date('1985-01-01'),
            max: new Date('2016-01-01'),
            unitStepSize: 5
          }
        }]
      }
    }
  });
};

var stackedXAxes = function stackedXAxes(id, multiply) {
  return [{
    stacked: true,
    ticks: {
      beginAtZero: true,
      max: 100,
      callback: function callback(value, index, values) {
        if (multiply) {
          value *= multiply;
        }
        return value + '%';
      }
    },
    gridLines: {
      display: false
    }
  }];
};

var stackedYAxes = function stackedYAxes(id) {
  return [{
    ticks: {
      beginAtZero: true
    },
    stacked: true,
    gridLines: {
      display: false
    },
    categoryPercentage: 0.6,
    barPercentage: 1
  }];
};

var percentageTooltip = function percentageTooltip(amount, label, multiply) {
  return label + ': ' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_utils_js__["b" /* percent */])(amount, amount >= 1 ? 1 : 2, multiply);
};

var bigTooltip = function bigTooltip(amount, label, unit) {
  amount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_utils_js__["a" /* commas */])(amount, amount >= 1 ? 1 : 2);
  return label + ': ' + amount + unit;
};

function MergeRecursive(obj1, obj2) {
  for (var p in obj2) {
    try {
      if (obj2[p].constructor === Object) {
        obj1[p] = MergeRecursive(obj1[p], obj2[p]);
      } else {
        obj1[p] = obj2[p];
      }
    } catch (e) {
      obj1[p] = obj2[p];
    }
  }
  return obj1;
}

var fold = function fold(s, n, useSpaces, a) {
  a = a || [];
  if (s.length <= n) {
    a.push(s);
    return a;
  }
  var line = s.substring(0, n);
  if (!useSpaces) {
    a.push(line);
    return fold(s.substring(n), n, useSpaces, a);
  } else {
    var lastSpaceRgx = /\s(?!.*\s)/;
    var idx = line.search(lastSpaceRgx);
    var nextIdx = n;
    if (idx > 0) {
      line = line.substring(0, idx);
      nextIdx = idx;
    }
    a.push(line);
    return fold(s.substring(nextIdx), n, useSpaces, a);
  }
};

/***/ }),

/***/ 169:
/***/ (function(module, exports) {



/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
if (false) {
  window.city = require('./assets/city.json');
  window.cities = require('./assets/cities.json');
}

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$city = window.city;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$cities = window.cities;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

Object.defineProperty(Array.prototype, 'chunk', {
  value: function value(chunkSize) {
    var R = [];
    for (var i = 0; i < this.length; i += chunkSize) {
      R.push(this.slice(i, i + chunkSize));
    }
    return R;
  }
});

String.prototype.replaceAll = function (search, replacement) {
  var target = this;
  return target.split(search).join(replacement);
};

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_City__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_City___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_City__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Toolbar__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Toolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Toolbar__);


__webpack_require__(169);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      section: 'map'
    };
  },

  components: {
    City: __WEBPACK_IMPORTED_MODULE_0__components_City___default.a,
    Toolbar: __WEBPACK_IMPORTED_MODULE_1__components_Toolbar___default.a
  }
});

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SectionDropdown__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SectionDropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__SectionDropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SectionSummary__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SectionSummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SectionSummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CityDropdown__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CityDropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CityDropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CitySummary__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CitySummary___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CitySummary__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MapGraphs__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MapGraphs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__MapGraphs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_utils_js__ = __webpack_require__(16);









/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'City',

  data: function data() {
    return {
      backgroundLoaded: false,
      city: this.$city,
      sectionKey: 0,
      maps: false,
      sections: [{
        section: 'city-header',
        title: 'Summary'
      }, {
        section: 'population',
        title: 'Population',
        graph: true,
        map: false
      }, {
        section: 'urban-extent',
        title: 'Urban Extent',
        graph: true,
        map: true
      }, {
        section: 'density',
        title: 'Density',
        graph: true,
        map: false
      }, {
        section: 'composition-of-added-area',
        title: 'Composition of Added Area',
        graph: false,
        map: true
      }, {
        section: 'roads',
        title: 'Roads',
        graph: true,
        map: true
      }, {
        section: 'arterial-roads',
        title: 'Arterial Roads',
        graph: true,
        map: true
      }, {
        section: 'blocks-and-plots',
        title: 'Blocks and Plots',
        graph: true,
        map: true
      }]
    };
  },

  computed: {
    currentSection: function currentSection() {
      return this.sections[this.sectionKey];
    },
    backgroundStyle: function backgroundStyle() {
      if (this.sectionKey !== 0) {
        return;
      }
      var vm = this;
      if (this.backgroundLoaded) {
        var image = '/file-manager/userfiles/photos/';
      } else {
        image = '/file-manager/userfiles/_med/photos/';
        this.loadImage('/file-manager/userfiles/photos/' + this.city.City.photo_path).then(function () {
          vm.backgroundLoaded = true;
        });
      }
      return {
        'background-image': 'linear-gradient(-180deg, #C5C5C5 0%, #616161 98%), url("' + image + this.city.City.photo_path + '")'
      };
    }
  },
  mounted: function mounted() {
    this.$parent.section = 'city-header';
  },

  methods: {
    commas: function commas() {
      return __WEBPACK_IMPORTED_MODULE_6__assets_utils_js__["a" /* commas */].apply(this, arguments);
    },
    loadImage: function loadImage(image) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var img = new Image();
        img.onload = function () {
          resolve();
        };
        img.src = image;
      });
    },
    setKey: function setKey(index) {
      this.sectionKey = index;
    }
  },
  watch: {
    currentSection: function currentSection() {
      this.$parent.section = this.currentSection.section;
    }
  },
  components: {
    MapGraphs: __WEBPACK_IMPORTED_MODULE_5__MapGraphs___default.a,
    SectionDropdown: __WEBPACK_IMPORTED_MODULE_1__SectionDropdown___default.a,
    SectionSummary: __WEBPACK_IMPORTED_MODULE_2__SectionSummary___default.a,
    CityDropdown: __WEBPACK_IMPORTED_MODULE_3__CityDropdown___default.a,
    CitySummary: __WEBPACK_IMPORTED_MODULE_4__CitySummary___default.a
  }
});

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'CityDropdown',
  props: ['city', 'sectionKey'],
  data: function data() {
    return {
      cities: this.$cities,
      dropdown: false,
      cityFilter: ''
    };
  },

  computed: {
    citiesOrdered: function citiesOrdered() {
      return this.cities.sort(function (a, b) {
        return a.Region.name === b.Region.name ? a.City.name > b.City.name ? 1 : -1 : a.Region.name > b.Region.name ? 1 : -1;
      });
    },
    citiesGrouped: function citiesGrouped() {
      return this.citiesFiltered.chunk(Math.ceil(this.cities.length / 4));
    },
    citiesFiltered: function citiesFiltered() {
      var _this = this;

      return this.citiesOrdered.filter(function (c) {
        return _this.cityFilter === '' || c.City.name.toLowerCase().includes(_this.cityFilter.toLowerCase()) || c.Region.name.toLowerCase().includes(_this.cityFilter.toLowerCase());
      });
    }
  },
  methods: {
    swapCity: function swapCity(city) {
      console.log(city);
    },
    lastRegion: function lastRegion(index, indexx, city) {
      if (index === 0 && indexx === 0) {
        return true;
      } else {
        var comboIndex = index * Math.ceil(this.cities.length / 4) + indexx - 1;
        var lastCity = this.citiesFiltered[comboIndex];
        return lastCity.Region.name !== city.Region.name;
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    var vm = this;
    document.addEventListener('click', function (e) {
      if (_this2.$refs.citydropdown && !_this2.$refs.citydropdown.contains(e.target)) {
        vm.dropdown = false;
      }
    }, false);
  }
});

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_utils_js__ = __webpack_require__(16);




/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'CitySummary',
  props: ['city', 'sectionKey'],
  data: function data() {
    return {
      dropdown: true
    };
  },

  computed: {
    flag: function flag() {
      return '/file-manager/userfiles/flags/' + this.city.City.flag_path;
    },
    year: function year() {
      return this.city.City.t3.substr(0, 4);
    }
  },
  methods: {
    commas: function commas(amount) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assets_utils_js__["a" /* commas */])(amount);
    }
  }
});

/***/ }),

/***/ 175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_graphing_js__ = __webpack_require__(168);



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'Graphs',
  props: ['section', 'city'],
  data: function data() {
    return {
      chartObjects: {},
      laterYear: true
    };
  },

  computed: {
    earlyRange: function earlyRange() {
      return this.city.City.t1.substr(0, 4) + '—' + this.city.City.t2.substr(0, 4);
    },
    laterRange: function laterRange() {
      return this.city.City.t2.substr(0, 4) + '—' + this.city.City.t3.substr(0, 4);
    }
  },
  mounted: function mounted() {
    this.launchGraphs();
  },
  destroyed: function destroyed() {
    this.destroyGraphs();
  },

  watch: {
    section: function section() {
      var _this = this;

      this.destroyGraphs();
      this.$nextTick(function () {
        _this.launchGraphs();
      });
    },
    laterYear: function laterYear() {
      this.changeYear();
    }
  },
  methods: {
    destroyGraphs: function destroyGraphs() {
      for (var key in this.chartObjects) {
        if (this.chartObjects.hasOwnProperty(key)) {
          this.chartObjects[key].destroy();
        }
      }
    },
    canvas: function canvas(id) {
      var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '400px';
      var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '300px';

      return '<canvas id=\'' + id + '\' class=\'city-graphic\'  width="' + width + '" height="' + height + '"></canvas>';
    },
    legend: function legend(id) {
      return this.chartObjects[id] && this.chartObjects[id].generateLegend();
    },
    arterialRoads: function arterialRoads() {
      var chart = {};
      var id = 'arterial_roads_density_bar';
      if (this.chartObjects[id]) this.chartObjects[id].destroy();
      chart[id] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_graphing_js__["a" /* makeRoadChart */])(id, this.city, 'Density of Arterial Roads (km/km&sup2;)', ' km/km&sup2;', undefined, this.laterYear);
      id = 'arterial_roads_walking_bar';
      if (this.chartObjects[id]) this.chartObjects[id].destroy();
      chart[id] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_graphing_js__["a" /* makeRoadChart */])(id, this.city, 'Share of Area Within Walking Distance of Arterial Roads', '%', 100, this.laterYear);
      id = 'arterial_roads_beeline_bar';
      if (this.chartObjects[id]) this.chartObjects[id].destroy();
      chart[id] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_graphing_js__["a" /* makeRoadChart */])(id, this.city, 'Beeline Distance to Arterial Roads', 'm', undefined, this.laterYear);
      this.chartObjects = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.chartObjects, chart);
    },
    blocksAndPlots: function blocksAndPlots() {
      var chart = {};
      var id = 'blocks_and_plots_composition_special_stacked';
      if (this.chartObjects[id]) this.chartObjects[id].destroy();
      chart[id] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_graphing_js__["b" /* makeSpecialStacked */])(id, this.city, 'Share of Residential Land Use Settlements', this.laterYear);
      this.chartObjects = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.chartObjects, chart);
    },
    changeYear: function changeYear() {
      var _this2 = this;

      switch (this.section.section) {
        case 'arterial-roads':
          var roads = ['arterial_roads_density_bar', 'arterial_roads_walking_bar', 'arterial_roads_beeline_bar'];
          roads.forEach(function (road) {
            var meta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_graphing_js__["c" /* returnRoadChartData */])(road, _this2.city, _this2.laterYear);
            meta.datasets.forEach(function (dataset, i) {
              var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, dataset.data);
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this2.chartObjects[road].config.data.datasets[i].data, data);
            });
            _this2.chartObjects[road].update();
          });
          break;
        case 'blocks-and-plots':
          var id = 'blocks_and_plots_composition_special_stacked';
          var meta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_graphing_js__["d" /* returnSpecialStacked */])(id, this.city, this.laterYear);
          meta.datasets.forEach(function (dataset, i) {
            var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, dataset.data);
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(_this2.chartObjects[id].config.data.datasets[i].data, data);
          });
          this.chartObjects[id].update();
          break;
      }
    },
    launchGraphs: function launchGraphs() {
      var chart = {};
      switch (this.section.section) {
        case 'population':
          var id = 'population_line';
          if (this.chartObjects[id]) this.chartObjects[id].destroy();
          chart[id] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_graphing_js__["e" /* makeLine */])(id, this.city, 'Population');
          id = 'population_change_bar';
          if (this.chartObjects[id]) this.chartObjects[id].destroy();
          chart[id] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_graphing_js__["f" /* makeChart */])(id, this.city, 'Population Avg. Annual % Change', '%');
          break;
        case 'urban-extent':
          id = 'urban_extent_composition_stacked_bar';
          if (this.chartObjects[id]) this.chartObjects[id].destroy();
          chart[id] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_graphing_js__["g" /* makeStacked */])(id, this.city, 'Urban Composition');
          id = 'urban_extent_change_bar';
          if (this.chartObjects[id]) this.chartObjects[id].destroy();
          chart[id] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_graphing_js__["f" /* makeChart */])(id, this.city, 'Urban Extent Avg. Annual % Change');
          break;
        case 'density':
          id = 'density_built_up_line';
          if (this.chartObjects[id]) this.chartObjects[id].destroy();
          chart[id] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_graphing_js__["e" /* makeLine */])(id, this.city, 'Built-up Area Density (Persons/Hectare)', ' Persons/Hectare');
          id = 'density_built_up_change_bar';
          if (this.chartObjects[id]) this.chartObjects[id].destroy();
          chart[id] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_graphing_js__["f" /* makeChart */])(id, this.city, 'Built-up Area Avg. Annual % Change');
          id = 'density_urban_extent_line';
          if (this.chartObjects[id]) this.chartObjects[id].destroy();
          chart[id] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_graphing_js__["e" /* makeLine */])(id, this.city, 'Urban Extent Density (Persons/Hectare)', ' Persons/Hectare');
          id = 'density_urban_extent_change_bar';
          if (this.chartObjects[id]) this.chartObjects[id].destroy();
          chart[id] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_graphing_js__["f" /* makeChart */])(id, this.city, 'Urban Extent Avg. Annual % Change');
          break;
        case 'composition-of-added-area':
          break;
        case 'roads':
          id = 'roads_in_built_up_area_bar';
          if (this.chartObjects[id]) this.chartObjects[id].destroy();
          chart[id] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_graphing_js__["f" /* makeChart */])(id, this.city, 'Share of built up area occupied by roads and boulevardse', '%', 100, true);
          id = 'roads_average_width_bar';
          if (this.chartObjects[id]) this.chartObjects[id].destroy();
          chart[id] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_graphing_js__["f" /* makeChart */])(id, this.city, 'Average Street Width', 'm', undefined, true);
          id = 'roads_width_stacked_bar';
          if (this.chartObjects[id]) this.chartObjects[id].destroy();
          chart[id] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_graphing_js__["g" /* makeStacked */])(id, this.city, 'Street Width Composition', undefined, undefined, true);
          break;
        case 'arterial-roads':
          this.arterialRoads();
          break;
        case 'blocks-and-plots':
          this.blocksAndPlots();
          id = 'blocks_plots_average_block_bar';
          if (this.chartObjects[id]) this.chartObjects[id].destroy();
          chart[id] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_graphing_js__["f" /* makeChart */])(id, this.city, 'Average Block Size (hectares)', ' hectares', undefined, true);
          id = 'blocks_plots_average_bar';
          if (this.chartObjects[id]) this.chartObjects[id].destroy();
          chart[id] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_graphing_js__["h" /* makeBlockChart */])(id, this.city, 'Average Plot Size (m&sup2;)', ' m&sup2;');
          break;
      }
      this.chartObjects = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.chartObjects, chart);
    }
  }
});

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Mapbox__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Mapbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Mapbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Graphs__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Graphs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Graphs__);





/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'MapGraphs',
  props: ['currentSection', 'city'],
  data: function data() {
    return {
      maps: true
    };
  },

  watch: {
    currentSection: function currentSection() {
      this.decideMap();
    }
  },
  mounted: function mounted() {
    this.decideMap();
  },

  methods: {
    decideMap: function decideMap() {
      this.maps = this.currentSection.map;
    }
  },
  components: {
    Mapbox: __WEBPACK_IMPORTED_MODULE_0__Mapbox___default.a,
    Graphs: __WEBPACK_IMPORTED_MODULE_1__Graphs___default.a
  }
});

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Mapkey__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Mapkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Mapkey__);



/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'Mapbox',
  props: ['city', 'section', 'mapkeyON'],
  components: {
    Mapkey: __WEBPACK_IMPORTED_MODULE_0__Mapkey___default.a
  },
  data: function data() {
    return {
      isMobile: false,
      map: false,
      light: false,
      lightBG: false,
      satBG: false,
      labelsMap: false,
      allLayers: {},
      layersLoading: [],
      host: '{s}.atlasofurbanexpansion.org',
      localhost: 'dev.atlasofurbanexpansion.org',
      maps: {
        'population': false,
        'urban-extent': [{
          on: true,
          display: 'Urban Built-Up',
          name: 'extent_??_urbanBuilt',
          url: '/urban_extent/urban_build_up_??/',
          color: '#978AD8'
        }, {
          on: true,
          display: 'Suburban Built-Up',
          name: 'extent_??_suburbanBuilt',
          url: '/urban_extent/suburban_build_up_??/',
          color: '#DCB8CA'
        }, {
          on: true,
          display: 'Rural Built-Up',
          name: 'extent_??_ruralBuilt',
          url: '/urban_extent/rural_build_up_??/',
          color: '#7C7C7C'
        }, {
          on: true,
          display: 'Urbanized Open Area',
          name: 'extent_??_urbanOpen',
          url: '/urban_extent/open_space_??/',
          color: '#F6F5A4'
        }, {
          on: true,
          display: 'Exurban Built-Up Area',
          name: 'extent_??_exurbanBuilt',
          url: '/urban_extent/exurban_built_up_??/',
          color: '#BCBCBC'
        }, {
          on: true,
          display: 'Exurban Open Space',
          name: 'extent_??_exurbanOpen',
          url: '/urban_extent/exurban_open_??/',
          color: '#E1E1E1'
        }],
        'density': false,
        'composition-of-added-area': [{ on: true, display: 'Built-up Area', name: 'addedArea_??_builtUp', url: '/added_area/built_up_area_??/', color: 'rgba(52,22,186,0.5)' }, { on: true, display: 'Infill', name: 'addedArea_??_infill', url: '/added_area/infill_??_!!/', color: 'rgba(255,1,196,0.5)' }, { on: true, display: 'Extension', name: 'addedArea_??_extension', url: '/added_area/extension_??_!!/', color: 'rgba(255,255,16,0.5)' }, { on: true, display: 'Leapfrog', name: 'addedArea_??_leapfrog', url: '/added_area/leapfrog_??_!!/', color: 'rgba(254,0,0,0.5)' }, { on: true, display: 'Inclusion', name: 'addedArea_??_inclusion', url: '/added_area/inclusion_??_!!/', color: 'rgba(53,136,102,0.5)' }],
        'arterial-roads': [{ on: true, name: 'arterials', url: '/arterials/arterials_t1/' }],
        'roads': [{ on: true, name: 'roads_??', url: '/roads/roads_??/' }],
        'blocks-and-plots': [{ on: true, name: 'blocks_land_use_??', url: '/blocks/land_use_??/' }, { on: true, display: 'Atomistic Settlements', color: '#CA9179' }, { on: true, display: 'Informal Subdivisions', color: '#BF614D' }, { on: true, display: 'Formal Subdivisions', color: '#A4352B' }, { on: true, display: 'Housing Projects', color: '#7E0812' }, { on: true, display: 'Open Space', color: '#7fe900' }, { on: true, display: 'Non Residential', color: '#9ce8ff' }]
      },
      timePeriods: ['t1', 't2', 't3']
    };
  },

  computed: {
    currentMap: function currentMap() {
      return this.maps[this.section.section];
    },
    stillLoading: function stillLoading() {
      return this.layersLoading.length > 0;
    }
  },
  mounted: function mounted() {
    this.map = L.mapbox.map('mapbox', null, {
      center: [this.city.City.latitude, this.city.City.longitude],
      reuseTiles: true,

      zoom: 11,
      zoomControl: false
    });
    new L.Control.Zoom({ position: 'bottomright' }).addTo(this.map);

    this.lightBG = L.mapbox.styleLayer('mapbox://styles/willcmccusker/cj44oki3u843e2rnx1wyilp8z').addTo(this.map);
    this.satBG = L.mapbox.styleLayer('mapbox://styles/willcmccusker/cj1s0rv49000w2sqm46rsl141').addTo(this.map);

    this.labelsMap = L.mapbox.styleLayer('mapbox://styles/willcmccusker/cj1s19z2u000l2snsh0t9i8gw').addTo(this.map);
    this.setLayers();
  },

  watch: {
    'section.section': function sectionSection() {
      this.setLayers();
    },
    'light': function light() {
      if (this.light) {
        this.map.removeLayer(this.satBG);
        this.lightBG.addTo(this.map);
      } else {
        this.map.removeLayer(this.lightBG);
        this.satBG.addTo(this.map);
      }
      this.setLabels();
    }
  },
  methods: {
    switchBG: function switchBG() {
      this.light = !this.light;
    },
    setLayer: function setLayer(i, on) {
      var layer = this.currentMap[i];
      layer.on = on;
      this.maps[this.section.section].splice(i, 1, layer);
    },
    addLayerLoader: function addLayerLoader(layerId) {
      this.layersLoading.push(layerId);
    },
    removeLayerLoader: function removeLayerLoader(layerId) {
      var i = this.layersLoading.indexOf(layerId);
      if (i !== -1) {
        this.layersLoading.splice(i, 1);
      }
    },
    removeLayer: function removeLayer(name) {
      if (this.allLayers[name]) {
        var layer = this.allLayers[name];
        if (this.map.hasLayer(layer)) {
          layer.bringToBack();
          this.map.removeLayer(layer);
        }
      }
    },
    getLayers: function getLayers() {
      var layers = [];
      this.map.eachLayer(function (layer) {
        if (layer.options.mine) {
          layers.push(layer);
        }
      });
      return layers;
    },
    removeAll: function removeAll() {
      var _this = this;

      this.map.eachLayer(function (layer) {
        if (layer.options.mine) {
          _this.map.removeLayer(layer);
        }
      });
    },
    generateLayer: function generateLayer(name, url, options) {
      return L.tileLayer(url, options);
    },
    addLayer: function addLayer(name) {
      if (this.allLayers[name]) {
        var layer = this.allLayers[name];
        if (!this.map.hasLayer(layer)) {
          this.map.addLayer(layer);
        }
        layer.bringToFront();
      }
    },
    addYearLayers: function addYearLayers(yearCount, options) {
      var _this2 = this;

      var inc = this.section.section === 'roads' || this.section.section === 'blocks-and-plots' ? 1 : 0;
      for (var i = 1; i < yearCount + 1; i++) {
        var j = i - inc;
        this.maps[this.section.section].forEach(function (layerType, count) {
          if ((_this2.section.section === 'roads' || _this2.section.section === 'blocks-and-plots') && count > 0) {
            return;
          }
          var name = layerType.name.replaceAll('??', 't' + j).replace('!!', 't' + (j + 1));
          options.name = name;
          var url = layerType.url.replaceAll('??', 't' + j).replace('!!', 't' + (j + 1));
          var u = 'http://' + _this2.host + '/tiles/show/' + _this2.city.City.slug + url + '{z}/{x}/{y}.png';
          var layer = _this2.generateLayer(name, u, options);

          if (!_this2.allLayers[name]) {
            _this2.allLayers[name] = layer;
          }
        });
      }
    },
    setLabels: function setLabels() {
      if (this.labelsMap) {
        this.labelsMap.bringToFront();
      }
    },
    setLayers: function setLayers() {
      var options = {
        tms: true,
        subdomains: 'abc',
        mine: true
      };
      switch (this.section.section) {
        case 'population':
          break;
        case 'urban-extent':
          for (var i = 0; i < 3; i++) {
            for (var j = 0; j < i + 1; j++) {
              var bound = j === 0 ? 'inner' : j === 1 ? 'middle' : 'outer';
              var name = 't' + (i + 1) + '_' + bound;
              options.opacity = 0.7;
              options.name = 'extent_' + name;
              if (!this.allLayers['extent_' + name]) {
                var u = 'http://' + this.host + '/tiles/show/' + this.city.City.slug + '/extent/' + name + '/{z}/{x}/{y}.png';
                this.allLayers['extent_' + name] = this.generateLayer(name, u, options);
              }
            }
          }

        case 'composition-of-added-area':
          var yearCount = this.section.section === 'urban-extent' ? 3 : 2;
          options.opacity = 1;
          this.addYearLayers(yearCount, options);
          this.map.setZoom(11);
          break;
        case 'arterial-roads':
          name = this.maps['arterial-roads'][0].name;
          options.name = name;
          options.opacity = 0.7;
          options.maxZoom = 17;
          if (!this.allLayers[name]) {
            var url = this.maps['arterial-roads'][0].url;

            u = 'http://' + this.host + '/tiles/show/' + this.city.City.slug + url + '/{z}/{x}/{y}.png';
            this.allLayers[name] = this.generateLayer(name, u, options);
          }
          this.map.setZoom(12);
          break;
        case 'blocks-and-plots':
        case 'roads':
          options.opacity = 0.7;
          options.maxZoom = 17;
          yearCount = 2;
          this.addYearLayers(yearCount, options);
          this.map.setZoom(15);
          break;
      }
      this.setLabels();
    }
  }
});

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'Mapkey',
  props: ['city', 'map', 'section', 'layers', 'light'],
  data: function data() {
    return {
      yearIndex: 1,
      extraLayersVisible: false,
      years: [{ checked: true }, { checked: true }, { checked: true }],
      spanKey: 1
    };
  },

  computed: {
    layersFiltered: function layersFiltered() {
      return this.layers.filter(function (l) {
        return l.color;
      });
    },
    alwaysChecked: function alwaysChecked() {
      switch (this.section.section) {
        case 'arterial-roads':
          return true;
        default:
          return false;
      }
    },
    periodLoop: function periodLoop() {
      switch (this.section.section) {
        case 'urban-extent':
          return this.yearsComputed;
        case 'composition-of-added-area':
        case 'roads':
        case 'blocks-and-plots':
        case 'arterial-roads':
          return this.spansComputed;
        default:
          return [];
      }
    },
    spansComputed: function spansComputed() {
      return [{
        display: this.city.City.t1.substr(0, 4) + '–' + this.city.City.t2.substr(0, 4),
        checked: this.spanKey === 0
      }, {
        display: this.city.City.t2.substr(0, 4) + '–' + this.city.City.t3.substr(0, 4),
        checked: this.spanKey === 1
      }];
    },
    yearsComputed: function yearsComputed() {
      return [{
        display: this.city.City.t1.substr(0, 4),
        checked: this.years[0].checked
      }, {
        display: this.city.City.t2.substr(0, 4),
        checked: this.years[1].checked
      }, {
        display: this.city.City.t3.substr(0, 4),
        checked: this.years[2].checked
      }];
    }
  },
  mounted: function mounted() {
    this.checkLayerPanel();
    if (this.map) {
      this.evaluateChecks();
    }
  },

  methods: {
    switchBG: function switchBG() {
      this.$emit('switch-bg');
    },
    layerStyle: function layerStyle(layer) {
      return layer.on && {
        'background-color': layer.color
      };
    },
    checkLayerPanel: function checkLayerPanel() {
      switch (this.section.section) {
        case 'urban-extent':
        case 'roads':
        case 'arterial-roads':
          this.extraLayersVisible = false;
          break;
        default:
          this.extraLayersVisible = true;
      }
    },
    checkLayer: function checkLayer(i, layer) {
      this.$parent.setLayer(i, !layer.on);
      this.evaluateChecks();
    },
    checkYear: function checkYear(i) {
      var _this = this;

      switch (this.section.section) {
        case 'urban-extent':
          if (this.extraLayersVisible) {
            this.years.forEach(function (year, ii) {
              _this.years[ii].checked = i === ii;
            });
          } else {
            this.years.splice(i, 1, { checked: !this.years[i].checked });
          }
          break;
        case 'composition-of-added-area':
        case 'roads':
        case 'blocks-and-plots':
          this.spanKey = i;
          break;
      }

      this.evaluateChecks();
    },
    period: function period(i) {
      return this.city.City['t' + (i + 1)].substr(0, 4);
    },
    evaluateChecks: function evaluateChecks() {
      var _this2 = this;

      switch (this.section.section) {
        case 'urban-extent':
        case 'composition-of-added-area':
          if (this.extraLayersVisible) {
            var timePeriod = 't' + (this.periodLoop.findIndex(function (y) {
              return y.checked;
            }) + 1);
            var timePeriod_ = 't' + (this.periodLoop.findIndex(function (y) {
              return y.checked;
            }) + 2);
            var layersToAdd = [];
            this.layers.forEach(function (layer) {
              if (layer.on) {
                layersToAdd.push(layer.name.replace('??', timePeriod).replace('!!', timePeriod_));
              }
            });
          } else {
            var sequence = '';
            this.years.forEach(function (y) {
              sequence += y.checked ? '1' : '0';
            });
            layersToAdd = [];
            switch (sequence) {
              case '000':
                break;
              case '100':
                layersToAdd.push('extent_t1_inner');
                break;
              case '110':
                layersToAdd.push('extent_t1_inner');
                layersToAdd.push('extent_t2_middle');
                break;
              case '101':
                layersToAdd.push('extent_t1_inner');
                layersToAdd.push('extent_t3_middle');
                layersToAdd.push('extent_t3_outer');
                break;
              case '111':
                layersToAdd.push('extent_t1_inner');
                layersToAdd.push('extent_t2_middle');
                layersToAdd.push('extent_t3_outer');
                break;
              case '010':
                layersToAdd.push('extent_t2_inner');
                layersToAdd.push('extent_t2_middle');
                break;
              case '011':
                layersToAdd.push('extent_t2_inner');
                layersToAdd.push('extent_t2_middle');
                layersToAdd.push('extent_t3_outer');
                break;
              case '001':
                layersToAdd.push('extent_t3_inner');
                layersToAdd.push('extent_t3_middle');
                layersToAdd.push('extent_t3_outer');
                break;
            }
          }
          var layersToRemove = this.$parent.getLayers();
          layersToRemove.forEach(function (layerToRemove) {
            var layerToAddKey = layersToAdd.findIndex(function (l) {
              return l === layerToRemove.options.name;
            });
            if (layerToAddKey > -1) {
              layersToAdd.splice(layerToAddKey, 1);
            } else {
              _this2.$emit('remove-layer', layerToRemove.options.name);
            }
          });
          layersToAdd.forEach(function (layer) {
            return _this2.$emit('add-layer', layer);
          });
          break;
        case 'arterial-roads':
          this.$parent.removeAll();
          this.$emit('add-layer', this.layers[0].name);
          break;
        case 'blocks-and-plots':
        case 'roads':
          this.$parent.removeAll();
          timePeriod = 't' + this.periodLoop.findIndex(function (y) {
            return y.checked;
          });
          console.log(timePeriod);
          console.log(this.layers[0].name.replace('??', timePeriod));
          this.$emit('add-layer', this.layers[0].name.replace('??', timePeriod));
          break;
        default:
          this.$parent.removeAll();
      }
      if (this.$parent.labelsMap) {
        this.$parent.labelsMap.bringToFront();
      }
    }
  },
  watch: {
    'section.section': function sectionSection() {
      this.checkLayerPanel();
      this.evaluateChecks();
    },
    map: function map() {
      this.evaluateChecks();
    },
    extraLayersVisible: function extraLayersVisible() {
      if (this.extraLayersVisible) {
        this.years[0].checked = false;
        this.years[1].checked = false;
        this.years[2].checked = true;
      }
      this.evaluateChecks();
    }
  }
});

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'SectionDropdown',
  props: ['sections', 'sectionKey'],
  data: function data() {
    return {
      dropdown: false
    };
  },

  computed: {
    currentSection: function currentSection() {
      return this.sections[this.sectionKey];
    }
  },
  mounted: function mounted() {
    var _this = this;

    var vm = this;
    document.addEventListener('click', function (e) {
      if (_this.$refs.sectiondropdown && !_this.$refs.sectiondropdown.contains(e.target)) {
        vm.dropdown = false;
      }
    }, false);
  },

  methods: {
    setKey: function setKey(index) {
      this.$emit('setKey', index);
      this.dropdown = false;
    }
  }
});

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_utils_js__ = __webpack_require__(16);




/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'SectionSummary',
  props: ['section', 'city'],
  data: function data() {
    return {
      dropdown: true
    };
  },

  computed: {
    t123Title: function t123Title() {
      var divs = '';
      for (var i = 1; i < 4; i++) {
        divs += '<div class="col-1-3 no-pad">\n                    <div class="summary-sub-title-num">' + this.city.City['t' + i].substr(0, 4) + '</div>\n                </div>';
      }
      return divs;
    },
    t12_23Title: function t12_23Title() {
      var divs = '';
      for (var i = 1; i < 3; i++) {
        divs += '<div class="col-1-2 no-pad">\n                    <div  class="summary-sub-title-num">' + this.city.City['t' + i].substr(0, 4) + '\u2013' + this.city.City['t' + (i + 1)].substr(0, 4) + '</div>\n                </div>';
      }
      return divs;
    },
    t1_3: function t1_3() {
      var divs = '';
      divs += '<div class="col-1-2 no-pad">\n                  <div  class="summary-sub-title-num">Pre ' + this.city.City['t1'].substr(0, 4) + '</div>\n              </div>';
      divs += '<div class="col-1-2 no-pad">\n                  <div  class="summary-sub-title-num">' + this.city.City['t1'].substr(0, 4) + '—' + this.city.City['t3'].substr(0, 4) + '</div>\n              </div>';
      return divs;
    }
  },
  methods: {
    enter: function enter(el, done) {},
    leave: function leave(el, done) {},
    title: function title(_title) {
      return '<div class=\'col-1-1\'>\n                <div class="summary-sub-title">' + _title + '</div>\n              </div>';
    },
    t123: function t123(key) {
      var divs = '';
      for (var i = 1; i < 4; i++) {
        divs += '<div class="col-1-3 no-pad">\n                    <div class=\'value\'>' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assets_utils_js__["a" /* commas */])(this.city.DataSet[key + '_t' + i]) + '</div>\n                </div>';
      }
      return divs;
    },
    changeT123: function changeT123(key) {
      var divs = '<div class="col-1-3"></div>';
      for (var i = 1; i < 3; i++) {
        divs += '<div class="col-1-3 no-pad">\n                    <div class=\'value\'>' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assets_utils_js__["b" /* percent */])(this.city.DataSet[key + '_t' + i + '_t' + (i + 1)]) + '</div>\n                </div>';
      }
      return divs;
    },
    changeT12_23: function changeT12_23(key) {
      var divs = '';
      for (var i = 1; i < 3; i++) {
        divs += '<div class="col-1-2  no-pad">\n                    <div class=\'value\'>' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assets_utils_js__["a" /* commas */])(this.city.DataSet[key + '_t' + i + '_t' + (i + 1)]) + '</div>\n                </div>';
      }
      return divs;
    },
    changeT1_13: function changeT1_13(key) {
      var perc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var divs = '';
      for (var i = 1; i < 3; i++) {
        var dates = i === 1 ? '_pre_1990' : '_1990_2015';
        var value = this.city.DataSet[key + dates];
        value = perc ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assets_utils_js__["b" /* percent */])(value) : value;
        divs += '<div class="col-1-2  no-pad">\n                    <div class=\'value\'>' + value + '</div>\n                </div>';
      }
      return divs;
    }
  }
});

/***/ }),

/***/ 181:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'Toolbar',

  data: function data() {
    return {
      search: false,
      menu: false,
      cities: this.$cities,
      searchFilter: '',
      poppedUp: false,
      linkGroups: [[{
        url: '/cities',
        display: 'Cities'
      }], [{
        url: '/about',
        display: 'About'
      }, {
        url: '/team',
        display: 'Team'
      }, {
        url: '/methodology',
        display: 'Methodology'
      }, {
        url: '/acknowledgements',
        display: 'Acknowledgements'
      }], [{
        url: '/data',
        display: 'Data'
      }, {
        url: '/historical-data',
        display: '30 Historical Cities'
      }, {
        url: 'http://atlasexpansionurbanacolombia.org',
        display: 'AUE – Colombia'
      }], [{
        url: 'mailto:contact@atlasofurbanexpansion.org',
        display: 'Contact'
      }]]
    };
  },
  mounted: function mounted() {
    document.addEventListener('keydown', this.keyDownTextField, false);
  },

  computed: {
    searchResults: function searchResults() {
      var vm = this;
      return this.cities.filter(function (city) {
        return vm.searchFilter !== '' && city.City.name.toLowerCase().includes(vm.searchFilter.toLowerCase());
      });
    },
    sideOpen: function sideOpen() {
      return this.menu || this.search;
    }
  },
  methods: {
    keyDownTextField: function keyDownTextField(e) {
      console.log(e.keyCode);
      if (e.key.length === 1 && !this.search) {
        this.search = true;
      } else if (e.keyCode === 27) {
        this.search = false;
      }
    },
    clicked: function clicked(b) {
      if (b === 's') {
        this.search = !this.search;
        this.menu = false;
      } else if (b === 'm') {
        if (this.sideOpen) {
          this.menu = false;
        } else {
          this.menu = !this.menu;
        }
        this.search = false;
      }
    }
  },
  watch: {
    search: function search() {
      if (this.search) {
        this.$nextTick(function () {
          this.$refs.input.focus();
        });
      } else {
        this.searchFilter = '';
      }
    }
  }
});

/***/ }),

/***/ 273:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 274:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 275:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 276:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 277:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 278:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 279:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 280:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 281:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 282:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 283:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 51,
	"./af.js": 51,
	"./ar": 58,
	"./ar-dz": 52,
	"./ar-dz.js": 52,
	"./ar-kw": 53,
	"./ar-kw.js": 53,
	"./ar-ly": 54,
	"./ar-ly.js": 54,
	"./ar-ma": 55,
	"./ar-ma.js": 55,
	"./ar-sa": 56,
	"./ar-sa.js": 56,
	"./ar-tn": 57,
	"./ar-tn.js": 57,
	"./ar.js": 58,
	"./az": 59,
	"./az.js": 59,
	"./be": 60,
	"./be.js": 60,
	"./bg": 61,
	"./bg.js": 61,
	"./bn": 62,
	"./bn.js": 62,
	"./bo": 63,
	"./bo.js": 63,
	"./br": 64,
	"./br.js": 64,
	"./bs": 65,
	"./bs.js": 65,
	"./ca": 66,
	"./ca.js": 66,
	"./cs": 67,
	"./cs.js": 67,
	"./cv": 68,
	"./cv.js": 68,
	"./cy": 69,
	"./cy.js": 69,
	"./da": 70,
	"./da.js": 70,
	"./de": 73,
	"./de-at": 71,
	"./de-at.js": 71,
	"./de-ch": 72,
	"./de-ch.js": 72,
	"./de.js": 73,
	"./dv": 74,
	"./dv.js": 74,
	"./el": 75,
	"./el.js": 75,
	"./en-au": 76,
	"./en-au.js": 76,
	"./en-ca": 77,
	"./en-ca.js": 77,
	"./en-gb": 78,
	"./en-gb.js": 78,
	"./en-ie": 79,
	"./en-ie.js": 79,
	"./en-nz": 80,
	"./en-nz.js": 80,
	"./eo": 81,
	"./eo.js": 81,
	"./es": 83,
	"./es-do": 82,
	"./es-do.js": 82,
	"./es.js": 83,
	"./et": 84,
	"./et.js": 84,
	"./eu": 85,
	"./eu.js": 85,
	"./fa": 86,
	"./fa.js": 86,
	"./fi": 87,
	"./fi.js": 87,
	"./fo": 88,
	"./fo.js": 88,
	"./fr": 91,
	"./fr-ca": 89,
	"./fr-ca.js": 89,
	"./fr-ch": 90,
	"./fr-ch.js": 90,
	"./fr.js": 91,
	"./fy": 92,
	"./fy.js": 92,
	"./gd": 93,
	"./gd.js": 93,
	"./gl": 94,
	"./gl.js": 94,
	"./gom-latn": 95,
	"./gom-latn.js": 95,
	"./he": 96,
	"./he.js": 96,
	"./hi": 97,
	"./hi.js": 97,
	"./hr": 98,
	"./hr.js": 98,
	"./hu": 99,
	"./hu.js": 99,
	"./hy-am": 100,
	"./hy-am.js": 100,
	"./id": 101,
	"./id.js": 101,
	"./is": 102,
	"./is.js": 102,
	"./it": 103,
	"./it.js": 103,
	"./ja": 104,
	"./ja.js": 104,
	"./jv": 105,
	"./jv.js": 105,
	"./ka": 106,
	"./ka.js": 106,
	"./kk": 107,
	"./kk.js": 107,
	"./km": 108,
	"./km.js": 108,
	"./kn": 109,
	"./kn.js": 109,
	"./ko": 110,
	"./ko.js": 110,
	"./ky": 111,
	"./ky.js": 111,
	"./lb": 112,
	"./lb.js": 112,
	"./lo": 113,
	"./lo.js": 113,
	"./lt": 114,
	"./lt.js": 114,
	"./lv": 115,
	"./lv.js": 115,
	"./me": 116,
	"./me.js": 116,
	"./mi": 117,
	"./mi.js": 117,
	"./mk": 118,
	"./mk.js": 118,
	"./ml": 119,
	"./ml.js": 119,
	"./mr": 120,
	"./mr.js": 120,
	"./ms": 122,
	"./ms-my": 121,
	"./ms-my.js": 121,
	"./ms.js": 122,
	"./my": 123,
	"./my.js": 123,
	"./nb": 124,
	"./nb.js": 124,
	"./ne": 125,
	"./ne.js": 125,
	"./nl": 127,
	"./nl-be": 126,
	"./nl-be.js": 126,
	"./nl.js": 127,
	"./nn": 128,
	"./nn.js": 128,
	"./pa-in": 129,
	"./pa-in.js": 129,
	"./pl": 130,
	"./pl.js": 130,
	"./pt": 132,
	"./pt-br": 131,
	"./pt-br.js": 131,
	"./pt.js": 132,
	"./ro": 133,
	"./ro.js": 133,
	"./ru": 134,
	"./ru.js": 134,
	"./sd": 135,
	"./sd.js": 135,
	"./se": 136,
	"./se.js": 136,
	"./si": 137,
	"./si.js": 137,
	"./sk": 138,
	"./sk.js": 138,
	"./sl": 139,
	"./sl.js": 139,
	"./sq": 140,
	"./sq.js": 140,
	"./sr": 142,
	"./sr-cyrl": 141,
	"./sr-cyrl.js": 141,
	"./sr.js": 142,
	"./ss": 143,
	"./ss.js": 143,
	"./sv": 144,
	"./sv.js": 144,
	"./sw": 145,
	"./sw.js": 145,
	"./ta": 146,
	"./ta.js": 146,
	"./te": 147,
	"./te.js": 147,
	"./tet": 148,
	"./tet.js": 148,
	"./th": 149,
	"./th.js": 149,
	"./tl-ph": 150,
	"./tl-ph.js": 150,
	"./tlh": 151,
	"./tlh.js": 151,
	"./tr": 152,
	"./tr.js": 152,
	"./tzl": 153,
	"./tzl.js": 153,
	"./tzm": 155,
	"./tzm-latn": 154,
	"./tzm-latn.js": 154,
	"./tzm.js": 155,
	"./uk": 156,
	"./uk.js": 156,
	"./ur": 157,
	"./ur.js": 157,
	"./uz": 159,
	"./uz-latn": 158,
	"./uz-latn.js": 158,
	"./uz.js": 159,
	"./vi": 160,
	"./vi.js": 160,
	"./x-pseudo": 161,
	"./x-pseudo.js": 161,
	"./yo": 162,
	"./yo.js": 162,
	"./zh-cn": 163,
	"./zh-cn.js": 163,
	"./zh-hk": 164,
	"./zh-hk.js": 164,
	"./zh-tw": 165,
	"./zh-tw.js": 165
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 284;

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(281)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(172),
  /* template */
  __webpack_require__(303),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(283)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(173),
  /* template */
  __webpack_require__(305),
  /* scopeId */
  "data-v-d9ca797a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(280)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(174),
  /* template */
  __webpack_require__(302),
  /* scopeId */
  "data-v-6fb4cee4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(273)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(175),
  /* template */
  __webpack_require__(295),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(279)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(176),
  /* template */
  __webpack_require__(301),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(275)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(177),
  /* template */
  __webpack_require__(297),
  /* scopeId */
  "data-v-25673d56",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(274)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(178),
  /* template */
  __webpack_require__(296),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(278)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(300),
  /* scopeId */
  "data-v-4a3ee33f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(277)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(180),
  /* template */
  __webpack_require__(299),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 294:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(282)

var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(181),
  /* template */
  __webpack_require__(304),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 295:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "section-graphs"
    }
  }, [(_vm.section.section === 'arterial-roads' || _vm.section.section === 'blocks-and-plots') ? _c('div', [_c('div', {
    staticClass: "grid change-years"
  }, [_c('div', {
    staticClass: "col-1-1"
  }, [_c('div', {
    staticClass: "change-year",
    class: {
      currentYear: !_vm.laterYear
    },
    on: {
      "click": function($event) {
        _vm.laterYear = false
      }
    }
  }, [_vm._v(_vm._s(_vm.earlyRange))]), _vm._v(" "), _c('div', {
    staticClass: "change-year",
    class: {
      currentYear: _vm.laterYear
    },
    on: {
      "click": function($event) {
        _vm.laterYear = true
      }
    }
  }, [_vm._v(_vm._s(_vm.laterRange))])])])]) : _vm._e(), _vm._v(" "), (_vm.section.section === 'population') ? _c('div', [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-1-2 tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('population_line'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('population_change_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hold-legend col-1-4 no-pad no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('population_change_bar'))
    }
  })])])]) : (_vm.section.section === 'urban-extent') ? _c('div', [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('urban_extent_composition_stacked_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hold-legend col-1-4 no-pad no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('urban_extent_composition_stacked_bar'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('urban_extent_change_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hold-legend col-1-4 no-pad no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('urban_extent_change_bar'))
    }
  })])])]) : (_vm.section.section === 'density') ? _c('div', [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-1-2 tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('density_built_up_line', undefined, undefined))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad no-pad mob-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('density_built_up_change_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hold-legend col-1-4 no-pad no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('density_built_up_change_bar'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-1-2 tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('density_urban_extent_line', undefined, undefined))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('density_urban_extent_change_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hold-legend col-1-4 no-pad no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('density_urban_extent_change_bar'))
    }
  })])])]) : (_vm.section.section === 'composition-of-added-area') ? _c('div') : (_vm.section.section === 'roads') ? _c('div', [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('roads_in_built_up_area_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-4 no-pad tab-1-1"
  }, [_c('div', {
    staticClass: "hold-legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('roads_in_built_up_area_bar'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('roads_average_width_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-4 no-pad tab-1-1"
  }, [_c('div', {
    staticClass: "hold-legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('roads_average_width_bar'))
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('roads_width_stacked_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-4 no-pad tab-1-1"
  }, [_c('div', {
    staticClass: "hold-legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('roads_width_stacked_bar'))
    }
  })])])])]) : (_vm.section.section === 'arterial-roads') ? _c('div', [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('arterial_roads_density_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-4 no-pad tab-1-1"
  }, [_c('div', {
    staticClass: "hold-legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('arterial_roads_density_bar'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('arterial_roads_walking_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-4 no-pad tab-1-1"
  }, [_c('div', {
    staticClass: "hold-legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('arterial_roads_walking_bar'))
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('arterial_roads_beeline_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-4 no-pad tab-1-1"
  }, [_c('div', {
    staticClass: "hold-legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('arterial_roads_beeline_bar'))
    }
  })])])])]) : (_vm.section.section === 'blocks-and-plots') ? _c('div', [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('blocks_and_plots_composition_special_stacked', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-4 no-pad tab-1-1"
  }, [_c('div', {
    staticClass: "hold-legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('blocks_and_plots_composition_special_stacked'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('blocks_plots_average_block_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-4 no-pad tab-1-1"
  }, [_c('div', {
    staticClass: "hold-legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('blocks_plots_average_block_bar'))
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-1-2 tab-1-1"
  }, [_c('div', {
    staticClass: "col-3-4 no-pad tab-1-1",
    domProps: {
      "innerHTML": _vm._s(_vm.canvas('blocks_plots_average_bar', '300px'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-1-4 no-pad tab-1-1"
  }, [_c('div', {
    staticClass: "hold-legend",
    domProps: {
      "innerHTML": _vm._s(_vm.legend('blocks_plots_average_bar'))
    }
  })])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 296:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "map-key"
    }
  }, [_c('div', {
    staticClass: "map-key-years"
  }, _vm._l((_vm.periodLoop), function(i, index) {
    return _c('div', {
      staticClass: "map-key-year",
      class: {
        current: i.checked, always: _vm.alwaysChecked
      },
      on: {
        "click": function($event) {
          _vm.checkYear(index)
        }
      }
    }, [_c('div', {
      staticClass: "map-key-checkbox"
    }), _vm._v(" "), _c('div', {
      staticClass: "map-key-period",
      domProps: {
        "innerHTML": _vm._s(i.display)
      }
    })])
  })), _vm._v(" "), (_vm.section.section === "urban-extent") ? _c('div', {
    staticClass: "cursor showLayers",
    on: {
      "click": function($event) {
        _vm.extraLayersVisible = !_vm.extraLayersVisible
      }
    }
  }, [_vm._v(_vm._s(_vm.extraLayersVisible ? 'Hide' : 'Show') + " Urban Composition")]) : _vm._e(), _vm._v(" "), (_vm.extraLayersVisible) ? _c('div', {
    staticClass: "map-key-layers "
  }, _vm._l((_vm.layersFiltered), function(layer, index) {
    return _c('div', {
      staticClass: "layer-action cursor",
      class: {
        'no-click': _vm.section.section === 'blocks-and-plots'
      },
      on: {
        "click": function($event) {
          _vm.checkLayer(index, layer)
        }
      }
    }, [_c('div', {
      staticClass: "layer-checkbox",
      style: (_vm.layerStyle(layer))
    }), _vm._v(" "), _c('div', {
      staticClass: "layer-title",
      domProps: {
        "innerHTML": _vm._s(layer.display)
      }
    })])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "satellite",
    on: {
      "click": _vm.switchBG
    }
  }, [_c('div', {
    class: {
      selected: !_vm.light
    }
  }, [_vm._v("Satellite")]), _c('div', {
    class: {
      selected: _vm.light
    }
  }, [_vm._v("Light")])])])
},staticRenderFns: []}

/***/ }),

/***/ 297:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "map"
    }
  }, [(!_vm.section.map) ? _c('div', {
    attrs: {
      "id": "map-cover"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mapkeyON) ? _c('mapkey', {
    attrs: {
      "light": _vm.light,
      "city": _vm.city,
      "map": _vm.map,
      "layers": _vm.currentMap,
      "section": _vm.section
    },
    on: {
      "switch-bg": _vm.switchBG,
      "remove-all": _vm.removeAll,
      "add-layer": _vm.addLayer,
      "remove-layer": _vm.removeLayer,
      "get-layers": _vm.getLayers
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "city-map",
    attrs: {
      "id": "mapbox"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 298:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('toolbar', {
    class: _vm.section
  }), _vm._v(" "), (_vm.$city) ? _c('city') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 299:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary",
    class: {
      open: _vm.dropdown
    },
    attrs: {
      "id": "section-summary"
    }
  }, [_c('div', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        _vm.dropdown = !_vm.dropdown
      }
    }
  }, [_c('div', {
    staticClass: "more-title"
  }, [_vm._v(_vm._s(_vm.section.title) + " Summary")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dropdown),
      expression: "dropdown"
    }],
    staticClass: "show-more"
  }, [(_vm.section.section === 'population') ? _c('div', [_c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.t123Title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('Population'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.t123('population'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('% Change'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.changeT123('population_change'))
    }
  })]) : (_vm.section.section === 'urban-extent') ? _c('div', [_c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.t123Title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('Urban Extent in Hectares'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.t123('urban_extent_actuals'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('% Change'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.changeT123('urban_extent_change'))
    }
  })]) : (_vm.section.section === 'density') ? _c('div', [_c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.t123Title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('Built-up Area Density (Person/Hectare)'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.t123('density_built_up'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('% Change'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.changeT123('density_built_up_change'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('Urban Extent Density (Person/Hectare)'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.t123('density_urban_extent'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('% Change'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.changeT123('density_urban_extent_change'))
    }
  })]) : (_vm.section.section === 'composition-of-added-area') ? _c('div', [_c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.t12_23Title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('Added Built-up Area in hectares'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.changeT12_23('added_area_total'))
    }
  })]) : (_vm.section.section === 'roads') ? _c('div', [_c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.t1_3)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('Average Road Width (m)'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.changeT1_13('roads_average_width'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('Share of built up area occupied by roads'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.changeT1_13('roads_in_built_up_area', true))
    }
  })]) : (_vm.section.section === 'arterial-roads') ? _c('div', [_c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.t1_3)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('Density of Arterial Roads (km/km&sup2;)'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.changeT1_13('arterial_roads_density_all'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('Share of built up area within walking distance of an arterial road'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.changeT1_13('arterial_roads_walking_all', true))
    }
  })]) : (_vm.section.section === 'blocks-and-plots') ? _c('div', [_c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.t1_3)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad no-pad-bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.title('Average Block Size (hectares)'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid no-pad",
    domProps: {
      "innerHTML": _vm._s(_vm.changeT1_13('blocks_plots_average_block'))
    }
  })]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 300:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown-nav cursor",
    class: {
      open: _vm.dropdown
    }
  }, [_c('div', {
    ref: "sectiondropdown",
    staticClass: "currentSection",
    on: {
      "click": function($event) {
        _vm.dropdown = !_vm.dropdown
      }
    }
  }, [_c('div', {
    staticClass: "graph-icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-title",
    domProps: {
      "innerHTML": _vm._s(_vm.sectionKey === 0 ? 'select a data set' : _vm.currentSection.title)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dropdown-arrow"
  }, [_c('img', {
    attrs: {
      "src": '/img/arrow-b.svg'
    }
  })])]), _vm._v(" "), (_vm.dropdown) ? _c('div', {
    staticClass: "allSections"
  }, _vm._l((_vm.sections), function(section, index) {
    return _c('div', [_c('div', {
      staticClass: "dropdown-title",
      domProps: {
        "innerHTML": _vm._s(section.title)
      },
      on: {
        "click": function($event) {
          _vm.setKey(index)
        }
      }
    })])
  })) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 301:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "map-graph"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "cursor",
    class: {
      selected: _vm.maps, disabled: !_vm.currentSection.map
    },
    on: {
      "click": function($event) {
        _vm.maps = true
      }
    }
  }, [_vm._v("Map")]), _vm._v(" "), _c('div', {
    staticClass: "cursor",
    class: {
      selected: !_vm.maps, disabled: !_vm.currentSection.graph
    },
    on: {
      "click": function($event) {
        _vm.maps = false
      }
    }
  }, [_vm._v("Graphs")])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), (_vm.currentSection.graph && !_vm.maps) ? _c('graphs', {
    attrs: {
      "city": _vm.city,
      "section": _vm.currentSection
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('mapbox', {
    class: {
      maps: _vm.maps, graphs: !_vm.maps
    },
    attrs: {
      "mapkeyON": _vm.maps,
      "city": _vm.city,
      "section": _vm.currentSection
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 302:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary",
    attrs: {
      "id": "city-summary"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "flag"
  }, [_c('img', {
    attrs: {
      "src": _vm.flag
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "country"
  }, [_vm._v(_vm._s(_vm.city.City.country))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Region")]), _vm._v(" "), _c('div', {
    staticClass: "region"
  }, [_vm._v(_vm._s(_vm.city.Region.name))])]), _vm._v(" "), (_vm.sectionKey != 0) ? _c('div', [_c('div', {
    staticClass: "cursor",
    class: {
      open: _vm.dropdown
    },
    on: {
      "click": function($event) {
        _vm.dropdown = !_vm.dropdown
      }
    }
  }, [_c('div', {
    staticClass: "more-title"
  }, [_vm._v("City Summary")])]), _vm._v(" "), (_vm.dropdown) ? _c('div', {
    staticClass: "show-more"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.year) + " Population")]), _vm._v(" "), _c('div', {
    staticClass: "amount",
    domProps: {
      "innerHTML": _vm._s(_vm.commas(_vm.city.City.population))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.year) + " Urban Extent")]), _vm._v(" "), _c('div', {
    staticClass: "amount",
    domProps: {
      "innerHTML": _vm._s(_vm.commas(_vm.city.City.extent) + ' persons/hectare')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.year) + " Density")]), _vm._v(" "), _c('div', {
    staticClass: "amount",
    domProps: {
      "innerHTML": _vm._s(_vm.commas(_vm.city.City.density) + ' hectares')
    }
  })]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 303:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.currentSection.section,
    style: (_vm.backgroundStyle),
    attrs: {
      "id": "cityContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "side-panel"
    }
  }, [_c('div', {
    attrs: {
      "id": "side-panel-1"
    }
  }, [_c('city-dropdown', {
    attrs: {
      "sectionKey": _vm.sectionKey,
      "city": _vm.city
    }
  }), _vm._v(" "), _c('city-summary', {
    attrs: {
      "sectionKey": _vm.sectionKey,
      "city": _vm.city
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "side-panel-2"
    }
  }, [_c('section-dropdown', {
    attrs: {
      "sections": _vm.sections,
      "sectionKey": _vm.sectionKey
    },
    on: {
      "setKey": _vm.setKey
    }
  }), _vm._v(" "), (_vm.sectionKey != 0) ? _c('section-summary', {
    attrs: {
      "city": _vm.city,
      "section": _vm.currentSection
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.currentSection.section === 'city-header') ? _c('div', {
    staticClass: "grid center",
    attrs: {
      "id": "city-header-data"
    }
  }, [_c('div', {
    staticClass: "col-1-3 mob-1-1"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.city.City.t3.substr(0, 4)) + " Population\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "value",
    domProps: {
      "innerHTML": _vm._s(_vm.commas(_vm.city.City.population))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-1-3 mob-1-1"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.city.City.t3.substr(0, 4)) + " Density\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "value",
    domProps: {
      "innerHTML": _vm._s(_vm.commas(_vm.city.City.density))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("\n      persons/hectare\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-1-3 mob-1-1"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.city.City.t3.substr(0, 4)) + " Urban Extent\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "value",
    domProps: {
      "innerHTML": _vm._s(_vm.commas(_vm.city.City.extent))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("\n        hectares\n      ")])])]) : [_c('map-graphs', {
    attrs: {
      "city": _vm.city,
      "currentSection": _vm.currentSection
    }
  })]], 2)
},staticRenderFns: []}

/***/ }),

/***/ 304:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "search-icon"
    },
    on: {
      "click": function($event) {
        _vm.clicked('s')
      }
    }
  }), _vm._v(" "), _c('div', {
    class: {
      open: _vm.sideOpen
    },
    attrs: {
      "id": "menu-icon"
    },
    on: {
      "click": function($event) {
        _vm.clicked('m')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "side-menu",
    class: {
      visible: _vm.sideOpen
    }
  }, [(_vm.menu) ? _c('div', _vm._l((_vm.linkGroups), function(links) {
    return _c('div', {
      staticClass: "linkGroup"
    }, _vm._l((links), function(link) {
      return _c('div', [_c('a', {
        attrs: {
          "href": link.url
        }
      }, [_vm._v(_vm._s(link.display))])])
    }))
  })) : (_vm.search) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchFilter),
      expression: "searchFilter"
    }],
    ref: "input",
    staticClass: "search",
    attrs: {
      "id": "search",
      "placeholder": "Type to Search"
    },
    domProps: {
      "value": (_vm.searchFilter)
    },
    on: {
      "focus": function($event) {
        _vm.poppedUp = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchFilter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, _vm._l((_vm.searchResults), function(city) {
    return _c('li', [_c('a', {
      attrs: {
        "href": '/cities/view/' + city.City.slug
      }
    }, [_c('div', {
      staticClass: "popup-city-li"
    }, [_c('div', {
      staticClass: "table img"
    }, [_c('div', {
      staticClass: "table-cell"
    }, [_c('img', {
      attrs: {
        "src": '/file-manager/userfiles/_thumbs/flags/' + city.City.flag_path.replace('.png', '.jpg')
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "popup-city-city",
      domProps: {
        "innerHTML": _vm._s(city.City.name)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "popup-city-region",
      domProps: {
        "innerHTML": _vm._s(city.Region.name)
      }
    })])])])
  }))]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "site-title"
    }
  }, [_c('h1', {
    attrs: {
      "id": "site-title"
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Atlas of Urban Expansion")])])])
}]}

/***/ }),

/***/ 305:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.sectionKey === 0) ? _c('div', [_c('div', {
    staticClass: "city-title"
  }, [_vm._v("\n        " + _vm._s(_vm.city.City.name) + "\n      ")])]) : _c('div', {
    ref: "citydropdown",
    staticClass: "dropdown-nav cursor",
    class: {
      open: _vm.dropdown
    }
  }, [_c('div', {
    staticClass: "currentSection",
    on: {
      "click": function($event) {
        _vm.dropdown = !_vm.dropdown
      }
    }
  }, [_c('div', {
    staticClass: "dropdown-title"
  }, [_vm._v(_vm._s(_vm.city.City.name))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-arrow"
  }, [_c('img', {
    attrs: {
      "src": '/img/arrow-b.svg'
    }
  })])]), _vm._v(" "), (_vm.dropdown) ? _c('div', {
    staticClass: "allCities"
  }, [_c('div', {
    staticClass: "city-filter"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cityFilter),
      expression: "cityFilter"
    }],
    attrs: {
      "placeholder": "Select a city or type to search"
    },
    domProps: {
      "value": (_vm.cityFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cityFilter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "close-search",
    on: {
      "click": function($event) {
        _vm.dropdown = false
      }
    }
  })]), _vm._v(" "), _vm._l((_vm.citiesGrouped), function(citiesGroup, index) {
    return _c('div', {
      staticClass: "cityGroup"
    }, _vm._l((citiesGroup), function(city, indexx) {
      return _c('div', [(_vm.lastRegion(index, indexx, city)) ? _c('div', {
        staticClass: "dropdown-region",
        class: {
          first: index === 0
        }
      }, [_vm._v("\n            " + _vm._s(city.Region.name) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "dropdown-title"
      }, [_c('a', {
        attrs: {
          "href": '/cities/view/' + city.City.slug
        }
      }, [_vm._v(_vm._s(city.City.name) + " - "), _c('span', {
        staticClass: "country-name"
      }, [_vm._v(_vm._s(city.City.country))])])])])
    }))
  })], 2) : _vm._e()])])
},staticRenderFns: []}

/***/ })

},[170]);


// WEBPACK FOOTER //
// static/js/app.1fa9e8a89fda34fbc831.js